import { render, staticRenderFns } from "./HistoricalCertificateFilter.vue?vue&type=template&id=3b6dfac8&scoped=true&"
import script from "./HistoricalCertificateFilter.vue?vue&type=script&lang=js&"
export * from "./HistoricalCertificateFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6dfac8",
  null
  
)

export default component.exports